import React, { useState } from 'react';
import { Form, Button, Panel, Stack, useToaster, Message } from 'rsuite';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import Brand from '@/components/Brand';
import Copyright from '@/components/Copyright';
import { forgotPassword } from '@/services/auth.service';

const ForgotPassword = () => {
  const { t } = useTranslation();
  const toaster = useToaster();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmitEmail = async () => {
    if (!email) {
      toaster.push(
        <Message closable showIcon type="error">
          {t('Please enter an email address')}
        </Message>,
        { placement: 'topCenter', duration: 3000 }
      );
      return;
    }

    setIsLoading(true);
    try {
      const response = await forgotPassword(email);
      console.log('Forgot password response:', response);
      toaster.push(
        <Message closable showIcon type="success">
          {t(response.message)}
        </Message>,
        { placement: 'topCenter', duration: 2000 }
      );
      navigate('/forgot-mfa', { state: { email } });
    } catch (error) {
      console.error('Forgot password error:', error);
      toaster.push(
        <Message closable showIcon type="error">
          {t(error.message || 'Something went wrong')}
        </Message>,
        { placement: 'topCenter', duration: 3000 }
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      direction="column"
      style={{
        height: '95vh'
      }}
    >
      <Panel style={{ width: 400 }}>
        <Brand />
        <center>
          <h5 style={{ color: '#0d47a1', marginBottom: 10 }}>WORKPOINT</h5>
        </center>
        <Form fluid>
          <Form.Group>
            <Form.ControlLabel>{t('Email address')}</Form.ControlLabel>
            <Form.Control
              name="email"
              type="email"
              value={email}
              onChange={setEmail}
              placeholder={t('Enter your email address')}
              required
            />
          </Form.Group>
          <Form.Group>
            <center>
              <Button
                loading={isLoading}
                disabled={isLoading}
                style={{ backgroundColor: '#0d47a1', color: 'white' }}
                block
                onClick={handleSubmitEmail}
              >
                {t('Send Validation Code')}
              </Button>
            </center>
          </Form.Group>
          <center>
            <Link to="/signin" style={{ marginTop: 20, display: 'inline-block' }}>
              {t('Back to Sign In')}
            </Link>
          </center>
        </Form>
      </Panel>
      <Copyright />
    </Stack>
  );
};

export default ForgotPassword;
